import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTranslation } from 'react-i18next';

import { TrafficChangeIndicator } from '../../../components/TrafficChangeIndicator';
import type { Trend } from '../../../domain/company';
import { formatWithSuffix } from '../../../services/numberFormat';

import {
  StyledTrafficVisitsInfo,
  StyledTrafficVisitsInfoBold,
  StyledTrafficVisitsDate,
  StyledTrafficVisitsInfoRow,
  StyledTrafficVisitsChart,
} from './styles';
import { useTrafficVisitsChart } from './useTrafficVisitsChart';

export const TrafficVisitsChart = ({ data }: { data: Trend[] }) => {
  const { t } = useTranslation();

  const { value, chartOptions, startDate, endDate } = useTrafficVisitsChart(data);

  const { y: totalVisits, date, prevDate, change } = value;

  return (
    <>
      <StyledTrafficVisitsInfo>
        <StyledTrafficVisitsInfoRow>
          <StyledTrafficVisitsInfoBold>{formatWithSuffix(totalVisits, 1)}</StyledTrafficVisitsInfoBold>
          {date}
        </StyledTrafficVisitsInfoRow>
        <StyledTrafficVisitsInfoRow>
          <TrafficChangeIndicator change={change} />
          {prevDate ? `${t('company.from')} ${prevDate}` : null}
        </StyledTrafficVisitsInfoRow>
      </StyledTrafficVisitsInfo>
      <StyledTrafficVisitsChart>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        <StyledTrafficVisitsDate>
          <span>{startDate}</span>
          <span>{endDate}</span>
        </StyledTrafficVisitsDate>
      </StyledTrafficVisitsChart>
    </>
  );
};
